/**
 * Traverse the scene graph and call the callback on each node until the callback returns false.
 */
export const traverseUntil = <TNode extends { children?: TNode[] }>(
  root: TNode,
  callback: (node: TNode) => false | void
): false | void => {
  let bailedOut: false | void = callback(root);

  if (bailedOut === false) {
    return bailedOut;
  }
  const children = root.children ?? [];
  for (let i = 0, l = children.length; i < l && bailedOut !== false; i++) {
    bailedOut = traverseUntil(children[i], callback);
  }

  return bailedOut;
};
